import datos from "src/services/datos";
import Swal from "sweetalert2";

const objectTipoTelefonos = new datos("tipo_telefonos");

export const getTipoTelefonos = async () => {
  objectTipoTelefonos.addCondition("tipo_telefonos", "id", 0, ">");

  const response = await objectTipoTelefonos.get();

  if (response) {
    return response.wsResponse.tipo_telefonos;
  }
  return response;
};

export const getTipoTelefonosPaginated = async (limit, offset) => {
  objectTipoTelefonos.addCondition("tipo_telefonos", "id", 0, ">");
  objectTipoTelefonos.addLimitCondition(limit, offset);
  const response = await objectTipoTelefonos.get();
  /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/

  let result = {};
  if (!response.wsResponse.empty) {
    result = {
      data: [...response.wsResponse.tipo_telefonos],
      total_records: response.wsResponse.total_records,
    };
    return result;
  }
};

export const postTipoTelefonos = async (estado) => {
  if (estado) {
    const data = {
      id: estado.id,
      nombre: estado.detalle,
    };
    const response = await objectTipoTelefonos.insert(data);

    if (response) {
      return response.wsResponse.tipo_telefonos;
    }
  }

  return false;
};

export const deleteTipoTelefonos = async (id) => {
  let status = false;
  await Swal.fire({
    title: "Esta seguro de que desea eliminar este tipo de telefono?",
    text: "Si sigue adelante, no se podran revertir los cambios!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, quiero eliminarlo!",
    cancelButtonText: "No, no estoy seguro!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      const userData = new datos('tipo_telefonos');
      let data = {
        id: id
      }
      const response = await userData.delete(data);

      if (response.status === "true") {
        status = true;
        await Swal.fire(
          "Eliminado!",
          "El tipo de telefono ha sido eliminado exitosamente",
          "success"
        );
      } else {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message
        });
      }
    }
  });

  return status;
};
